import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../common/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators';

import { ApiUrlService } from '../common/api-url.service';
import { Folder } from './folder.model';

@Injectable({
    providedIn: 'root'
})
export class FolderApiService
{
    protected apiService: ApiService;

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService)
    {
        this.apiService = new ApiService(http);
    }

    getFolder(id: number): Observable<Folder>
    {
        return this.apiService.apiRequest(this.apiUrlService.getFolderUrl(id), HttpMethod.Get)
            .pipe(map(json => new Folder(json)));
    }
}
